/** Anulowany rekord zostaje klikalny, ale nie ma udawać żywego — ten sam wygląd w tabeli, wyszukiwarce i panelu spraw. */
export const CANCELLED_RECORD_CLASS = 'text-neutral-400 line-through';
